import { CompanyLogo } from '@components/pages/SubscribeTest/OfferSelection/TheInformationPro/Companies';
import { IMGIX_URL } from '@src/env';

export const companies: CompanyLogo[] = [
  {
    name: 'Apple',
    className: 'h-[25px] w-[20px] sm:h-[28px] sm:w-[23px]',
    path: `${IMGIX_URL}/global/landing_pages/asia_tech_coverages/pro/apple_logo.png`,
  },
  {
    name: 'Google',
    className: 'h-[19px] w-[56px] sm:h-[22px] sm:w-[65px]',
    path: `${IMGIX_URL}/global/landing_pages/asia_tech_coverages/pro/google_logo.png`,
  },
  {
    name: 'Microsoft',
    className: 'h-[20px] w-[93px] sm:h-[23px] sm:w-[107px]',
    path: `${IMGIX_URL}/global/landing_pages/asia_tech_coverages/pro/microsoft_logo.png`,
  },
  {
    name: 'Meta',
    className: 'h-[12px] w-[59px] sm:h-[15px] sm:w-[74px]',
    path: `${IMGIX_URL}/global/landing_pages/asia_tech_coverages/pro/meta_logo.png`,
  },
  {
    name: 'Nvidia',
    className: 'h-[16px] w-[87px] sm:h-[19px] sm:w-[97px]',
    path: `${IMGIX_URL}/global/landing_pages/asia_tech_coverages/pro/nvidia_logo.png`,
  },
  {
    name: 'Amazon',
    className: 'h-[17px] w-[56px] sm:h-[20px] sm:w-[66px]',
    path: `${IMGIX_URL}/global/landing_pages/asia_tech_coverages/pro/amazon_logo.png`,
  },
];

export const TESTIMONIAL_POST_IMG_URL =
  'https://tii.imgix.net/global/landing_pages/asia_tech_coverages/video_cover.png?dpi=2&format=auto';
export const TESTIMONIAL_VIDEO_URL =
  'https://tii.imgix.net/global/landing_pages/asia_tech_coverages/the-information-testimonial.mp4';

export const JING_YANG_TRENDING_POST_IMG_URL =
  'https://tii.imgix.net/global/landing_pages/asia_tech_coverages/jing_video_cover.png?dpi=2&format=auto';

export const JING_YANG_TRENDING_VIDEO_URL =
  'https://tii.imgix.net/global/landing_pages/asia_tech_coverages/Jing_video_trend.mp4';

export const TRUSTED_LOGOS = [
  {
    name: 'Sequoia',
    className: 'h-[16px] w-[117px] sm:h-[18px] sm:w-[132px]',
    path: 'landing_pages/asia_tech_coverages/sequoia_logo.png',
    sizes: '130px',
  },
  {
    name: 'Apple',
    className: 'h-[43px] w-[45px] sm:h-[50px] sm:w-[52px]',
    path: 'landing_pages/asia_tech_coverages/apple_logo.png',
    sizes: '50px',
  },
  {
    name: 'Goldman',
    className: 'h-[43px] w-[43px] sm:h-[50px] sm:w-[50px]',
    path: 'landing_pages/asia_tech_coverages/goldman_logo.png',
    sizes: '50px',
  },
  {
    name: 'Google',
    className: 'h-[43px] w-[43px] sm:h-[50px] sm:w-[50px]',
    path: 'landing_pages/asia_tech_coverages/google_logo.png',
    sizes: '50px',
  },
  {
    name: 'Meta',
    className: 'h-[54px] w-[68px] sm:h-[61px] sm:w-[76px]',
    path: 'landing_pages/asia_tech_coverages/meta_logo.png',
    sizes: '70px',
  },
];
